import { render, staticRenderFns } from "./OriginIcon.vue?vue&type=template&id=47906826&scoped=true&"
import script from "./OriginIcon.vue?vue&type=script&lang=js&"
export * from "./OriginIcon.vue?vue&type=script&lang=js&"
import style0 from "./OriginIcon.vue?vue&type=style&index=0&id=47906826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47906826",
  null
  
)

export default component.exports